<style>
  .x-small-icon {
    font-size: 1.5em;
  }

  .small-icon {
    font-size: 2em;
  }
  .medium-icon {
    font-size: 2.5em;
  }
  .large-icon {
    font-size: 3em;
  }
  .x-large-icon {
    font-size: 3.5em;
  }

  i {
    padding-right: 8px;
  }
</style>

<h2>Iconography</h2>

<p>
  We're using the Google Material Symbols, found
  <a href="https://fonts.google.com/icons" target="_blank">here</a>
</p>

<table>
  @for (icon of iconTypesKeys; track icon) {
    <tr>
      <td>
        <h4>{{ icon }}</h4>
        <app-icon
          [type]="icon"
          [class]="'xxsmall'"
          [style]="'padding-right:7px;'"
        ></app-icon>
        <app-icon
          [type]="icon"
          [class]="'xsmall'"
          [style]="'padding-right:7px;'"
        ></app-icon>
        <app-icon
          [type]="icon"
          [class]="'small'"
          [style]="'padding-right:7px;'"
        ></app-icon>
        <app-icon
          [type]="icon"
          [class]="'medium'"
          [style]="'padding-right:7px;'"
        ></app-icon>
        <app-icon
          [type]="icon"
          [class]="'large'"
          [style]="'padding-right:7px;'"
        ></app-icon>
        <app-icon
          [type]="icon"
          [class]="'xlarge'"
          [style]="'padding-right:7px;'"
        ></app-icon>
      </td>
      <td>
        <textarea codeSnippet [innerHTML]="getCodeSnippet(icon)"></textarea>
      </td>
    </tr>
  }
</table>
